import type { GetExperimentAnalysisOpenAPIQueryParams } from '../generated/operations/raw-openapi-query-params-for-serializers';

export interface GetExperimentAnalysisQueryParams extends GetExperimentAnalysisOpenAPIQueryParams {
  attributes?: Array<{ name: string; values: Array<string | number | boolean> }>;
  mcc?: 'disabled';
  sequentialTesting?: 'disabled';
  cuped?: 'disabled';
}

export function querySerializer(queryParams: GetExperimentAnalysisQueryParams) {
  const searchParams = new URLSearchParams();

  if (queryParams.iterationId) {
    searchParams.set('iterationId', queryParams.iterationId);
  }

  if (queryParams.attributes) {
    searchParams.set('attributes', JSON.stringify(queryParams.attributes));
  }

  if (queryParams.mcc) {
    searchParams.set('mcc', queryParams.mcc);
  }

  if (queryParams.sequentialTesting) {
    searchParams.set('sequentialTesting', queryParams.sequentialTesting);
  }

  if (queryParams.cuped) {
    searchParams.set('cuped', queryParams.cuped);
  }

  return searchParams.toString();
}
